import { useOpenBaas } from "../Context/SdkBaasOpen";

function useErrorComponent() {
  const { Error401 } = useOpenBaas();
  return { Error401 };
}

export default useErrorComponent;
